import * as actionTypes from './actionTypes'

import subjectTestApi from './../../api/subjTest';

const subjectTestRequest = () => ({
  type: actionTypes.SUBJ_TEST_REQUEST
});

const subjectTestReceive = data => ({
  type: actionTypes.SUBJ_TEST_RECEIVE,
  data,
});

const subjectTestError = error => ({
  type: actionTypes.SUBJ_TEST_ERROR,
  error,
});

const subjectTestFetch = () => dispatch => {
  dispatch(subjectTestRequest());
  return subjectTestApi.getSubjTest().then(data => dispatch(subjectTestReceive(data))).catch(error => dispatch(subjectTestError(error)));
};

const subjectTestShouldFetch = state => {
  const tasksState = state;
  if (tasksState.isFetching) {
    return true;
  }
  if (!tasksState.data) {
    return false;
  }
  return tasksState.didInvalidate;
};

export const subjectTestFetchIfNeeded = () => (dispatch, getState) => {
  if (!subjectTestShouldFetch(getState().tasks)) {
    return Promise.resolve();
  }
  return dispatch(subjectTestFetch());
};

export const subjectTestSet = data => (dispatch) => {
  dispatch(subjectTestRequest());
  return subjectTestApi.nextStep(data).then(data => dispatch(subjectTestReceive(data))).catch(error => dispatch(subjectTestError(error)));
};



// WEBPACK FOOTER //
// ./src/store/subjectTest/actions.js